import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { HttpUtils } from '../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';
let networkTreeRootNodes = require('assets/network-tree-nodes/root-nodes.json');

@Injectable()
export class InventoryService {

    nodes = [];
    networkNodes = [];
    constructor(public http: HttpClient) {
    }

    getTreeNodes(url) {
        return this.http.get(HttpUtils.getBaseUrl() + url).map((res: any) => this.nodes = res);
    }

    getChildNodes(url) {
        return this.http.get(HttpUtils.getBaseUrl() + url).toPromise();
    }

    getNetworkTreeRootNodes() {
        return this.http.get('assets/network-tree-nodes/root-nodes.json').map((res: any) => this.networkNodes = res);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/inventory-main/services/inventory.service.ts